module.exports = __webpack_public_path__ + "img/coinbankB31.d734d210.jpg";